import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { Modusign36h } from '@app/components/Logos';
import { isAuthenticated } from '@app/store/account/selectors';

const propTypes = {
  children: PropTypes.node,
  isAuth: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }).isRequired,
};

const defaultProps = {
  children: null,
};

export function PasswordLayoutComponent({ children, isAuth, history }) {
  useEffect(() => {
    if (isAuth) {
      history.replace('/documents');
    }
  }, [isAuth, history]);
  return (
    <div className="Background-Legacy Background--light-gray">
      <div className="Container Container--max-xs align-center">
        <a href="https://modusign.co.kr" rel="noopener noreferrer">
          <Modusign36h style={{ marginBottom: 12 }} />
        </a>
        <div className="Card Card--theme-flat box-6x align-left">{children}</div>
      </div>
    </div>
  );
}

PasswordLayoutComponent.propTypes = propTypes;
PasswordLayoutComponent.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  isAuth: isAuthenticated(state),
});

export default connect(mapStateToProps, null)(PasswordLayoutComponent);
